import React, { createContext, useContext, useState, useEffect } from 'react';
import { translations } from './translations';

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    // Check localStorage, fallback to 'uz'
    const savedLang = localStorage.getItem('language');
    return savedLang && ['en', 'ru', 'uz'].includes(savedLang) ? savedLang : 'uz';
  });

  useEffect(() => {
    localStorage.setItem('language', language);
    // Also set HTML lang attribute for accessibility
    document.documentElement.lang = language;
  }, [language]);

  const t = (key) => {
    // Check if translation exists for current language
    if (translations[language] && translations[language][key]) {
      return translations[language][key];
    }
    
    // Fallback to English if key doesn't exist in current language
    if (translations['en'] && translations['en'][key]) {
      console.warn(`Missing translation for key "${key}" in language "${language}"`);
      return translations['en'][key];
    }
    
    // Last resort: return the key itself
    console.error(`Missing translation for key "${key}" in all languages`);
    return key;
  };

  const changeLanguage = (lang) => {
    if (['en', 'ru', 'uz'].includes(lang)) {
      setLanguage(lang);
    } else {
      console.error(`Invalid language code: ${lang}`);
    }
  };

  return (
    <LanguageContext.Provider value={{ language, changeLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};